import { render, staticRenderFns } from "./CoursesPage.vue?vue&type=template&id=247ed218&scoped=true&"
import script from "./CoursesPage.vue?vue&type=script&lang=js&"
export * from "./CoursesPage.vue?vue&type=script&lang=js&"
import style0 from "./CoursesPage.vue?vue&type=style&index=0&id=247ed218&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "247ed218",
  null
  
)

export default component.exports